import SchoolInformation from "../components/SchoolInformation/SchoolInformation";

export default function SchoolView(){
    return (
        <>
            <SchoolInformation />
        </>
    )
}